// TableDisplay.js
import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import './table.css'

const TableDisplay = ({ itemDetails }) => {
    return (
        <div>
            {itemDetails.map((item, index) => (
                <div key={index}>
                    {item.tableName !== ('Unknown Table') && (
                        <h6 className='tablelabel'>{item.tableName}</h6>)}
                    <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                        <Table sx={{ minWidth: 650 }} aria-label="customized table">
                            <TableBody>
                                {Object.values(item.tableData).map((row, rowIndex) => (
                                    <TableRow key={rowIndex} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        {Object.values(row).map((cellData, cellIndex) => (
                                            <TableCell key={cellIndex} align="left">
                                                {cellData}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            ))}
        </div>
    );
};

export default TableDisplay;
